import { apiDownload, apiRequest } from './apiClient';
import { DashboardFilters, DashboardResponse } from '../types/dashboard';

function toQuery(values: object): string {
  const query = new URLSearchParams();
  Object.entries(values).forEach(([key, value]) => {
    if (value !== undefined && value !== '') query.set(key, String(value));
  });
  const serialized = query.toString();
  return serialized ? `?${serialized}` : '';
}

export function carregarDashboard(token: string, filters: DashboardFilters): Promise<DashboardResponse> {
  return apiRequest<DashboardResponse>(`/relatorios/dashboard${toQuery(filters)}`, token);
}

export function baixarRelatorioCsv(
  token: string,
  type: 'leitos' | 'documentos' | 'creditos-comissoes',
  filters: DashboardFilters,
): Promise<Blob> {
  const query: Record<string, string | undefined> = {
    formato: 'csv', dataInicio: filters.dataInicio, dataFim: filters.dataFim,
    clienteEmpresaId: filters.clienteEmpresaId,
  };
  if (type === 'leitos') { query.regiao = filters.regiao; query.status = filters.leitoStatus; }
  if (type === 'documentos') query.empresaId = filters.clienteEmpresaId;
  return apiDownload(`/relatorios/${type}${toQuery(query)}`, token);
}
